import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ServiceCatelogue.css';
import { APIURL, TZ } from "../../../Global";
import { useTranslation } from 'react-i18next';

const SideMenu = ({ selectedCategory, setSelectedCategory, selectedSub, setSelectedSub }) => {
  const [serviceSubs, setServiceSubs] = useState([]);
  const [productSubs, setProductSubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  useEffect(() => {
    const fetchCategories = async () => {
      const tokenString = sessionStorage.getItem('usertoken');
      let str = tokenString.replace(/["]+/g, '');
      setLoading(true);
      try {
        const res = await axios.get(`${APIURL}/api/v1/staff/vendor-categories/`,{
          headers: {
            "Authorization": 'Token ' + str
          }
        });
        if (res.data.status === 'success') {
          setServiceSubs(res.data.service_categories || []);
          setProductSubs(res.data.product_categories || []);
        }
      } catch (err) {
        setServiceSubs([]);
        setProductSubs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    if (!loading) {
      if (selectedCategory === 'Services' && serviceSubs.length > 0) {
        setSelectedSub(serviceSubs[0]);
      } else if (selectedCategory === 'Products' && productSubs.length > 0) {
        setSelectedSub(productSubs[0]);
      }
    }
    // Only run when selectedCategory or subs change
  }, [selectedCategory, serviceSubs, productSubs, loading, setSelectedSub]);

  const categories = [
    {
      title: 'Services',
      subs: serviceSubs,
    },
    {
      title: 'Products',
      subs: productSubs,
    },
  ];

  return (
    <div className="side-menu">
      {loading ? (
        <div>Loading...</div>
      ) : (
        categories.map((cat) => (
          <div key={cat.title}>
            <div
              className={`side-menu-main ${selectedCategory === cat.title ? 'active' : ''}`}
              onClick={() => setSelectedCategory(cat.title)}
            >
              <span role="img" aria-label="folder">📁</span> {t(cat.title.toLowerCase())}
            </div>
            {selectedCategory === cat.title && (
              <div className="side-menu-subs" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                {cat.subs.map((sub) => (
                  <div 
                    key={`${cat.title}-${sub}`}
                    className={`side-menu-sub ${selectedSub === sub ? 'active' : ''}`}
                    onClick={() => setSelectedSub(sub)}
                  >
                    <span role="img" aria-label="folder" >📄</span> {t(sub.toLowerCase())}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default SideMenu;
